 document.addEventListener("DOMContentLoaded", function () {
  const observer = new MutationObserver(updateTextAndExtractQuantity);
  var targetNode = document.querySelector(".product-grid-container");
  let finalPriceElements = document.querySelectorAll(
    ".product-information #final-price-precents-desktop .money"
  );
  let firstPriceElements = document.querySelectorAll(
    ".product-information  .price  .amount"
  );
  let firstPriceElementsDiscount = document.querySelectorAll(
    ".product-information #first-price del .money"
  );

  let variantTypeActive = "";
  let variantColorActive = "";

  const checkBoboCroco = (selectedProductName) => {

    if (selectedProductName !== "Black Croco" || selectedProductName !== "Raspberry") {
      // finalPriceElements.forEach(function (element) {
      //   element.textContent = "$239 USD";
      // });

      firstPriceElements.forEach(function (element) {
        element.textContent = "$299 USD";
      });
    }

    //     if (selectedProductName == "Raspberry") {
    //   finalPriceElements.forEach(function (element) {
    //     element.textContent = "$263 USD";
    //   });  

    //       firstPriceElementsDiscount.forEach(function (element) {
    //     element.textContent = "$329 USD";
    //   });

    //   let addToCartButton = document.querySelectorAll(
    //     ".single-add-to-cart-button--text"
    //   );

    //   addToCartButton.forEach((button) => {
    //     console.log(button);
    //     button.textContent = "Pre-Order Now";
    //   });
    // }
  };

  const checkTrolalaCroco = (selectedProductName) => {
    if (selectedProductName == "Black Croco") {
      // finalPriceElements.forEach(function(element) {
      //     element.textContent = '$463 USD';
      // });

      firstPriceElements.forEach(function (element) {
        element.textContent = "$579 USD";
      });
    }

    if (selectedProductName !== "Black Croco") {
      // finalPriceElements.forEach(function (element) {
      //   element.textContent = "$439 USD";
      // });

      firstPriceElements.forEach(function (element) {
        element.textContent = "$549 USD";
      });
    }
  };

  const checkBebeCroco = (selectedProductName) => {
    console.log("BEBREBEB", selectedProductName)
    if (selectedProductName == "Raspberry") {
      console.log("rasppp")
      // finalPriceElements.forEach(function (element) {
      //   console.log("rasppp")
      //   element.textContent = "$224 USD";
      // });

      firstPriceElements.forEach(function (element) {
        element.innerHTML = `<span class="price-promo">
        <span style="color: grey; text-decoration: line-through; margin-right: 5px;">USD $299</span>
        <ins><span class="money">USD $199</span></ins>
        </span>`;
      });
    }

    if (selectedProductName !== "Raspberry") {
      // finalPriceElements.forEach(function (element) {
      //   element.textContent = "$209 USD";
      // });

      firstPriceElements.forEach(function (element) {
        element.textContent = "$279 USD";
      });
    }
  };

  const checkGiftCard = (selectedProductName) => {
    if (selectedProductName == "$100") {
      // finalPriceElements.forEach(function (element) {
      //   element.textContent = "$80 USD";
      // });

      firstPriceElements.forEach(function (element) {
        element.textContent = "$100 USD";
      });
    }

    if (selectedProductName == "$200") {
      // finalPriceElements.forEach(function (element) {
      //   element.textContent = "$160 USD";
      // });

      firstPriceElements.forEach(function (element) {
        element.textContent = "$200 USD";
      });
    }

    if (selectedProductName == "$400") {
      // finalPriceElements.forEach(function (element) {
      //   element.textContent = "$320 USD";
      // });

      firstPriceElements.forEach(function (element) {
        element.textContent = "$400 USD";
      });
    }

    if (selectedProductName == "$600") {
      // finalPriceElements.forEach(function (element) {
      //   element.textContent = "$480 USD";
      // });

      firstPriceElements.forEach(function (element) {
        element.textContent = "$600 USD";
      });
    }
  };

  const checkDoquintin = () => {
    // finalPriceElements.forEach(function(element) {
    //     element.textContent = '$336 USD';
    // });

    let firstPriceElementsDoq = document.querySelectorAll(".amount del .money");

    firstPriceElementsDoq.forEach(function (element) {
      element.textContent = "420 USD";
    });
  };

  const checkStrap = (selectedProductName) => {
    // const firstPrice = document.querySelector("#strap-first-price");
    // const secondPrice = document.querySelector("#strap-second-price");

    if (selectedProductName == "bobobark strap") {
      //       finalPriceElements.forEach(function (element) {
      //   element.textContent = "$33 USD";
      //         console.log(element)
      // });

      firstPriceElements.forEach(function (element) {
        element.textContent = "$45 USD";
      });
    }

    if (selectedProductName !== "bebebark strap") {
      // finalPriceElements.forEach(function (element) {
      //   element.textContent = "$29 USD";
      // });

      firstPriceElements.forEach(function (element) {
        element.textContent = "$39 USD";
      });
    }
  };

  function updateTextAndExtractQuantity() {
    observer.disconnect();
    const text = document.getElementById("alert-text");
    const button = document.querySelector(".restock-alerts-float-button");

    const labelValueChecker = targetNode.querySelectorAll(
      ".form__label__value"
    );

    if (labelValueChecker && labelValueChecker.length > 1) {
      const productType = labelValueChecker[0].textContent.trim();
      const productColor = labelValueChecker[1].textContent.trim();
      variantTypeActive = productType;
      variantColorActive = productColor;
      const userGeolocation = localStorage.getItem("userGeolocation");
      hideUnavailableVariants(userGeolocation);
    }

    const labelValue = targetNode.querySelector(".form__label__value");
    const itemNameElements = document.querySelectorAll(".name-of-item");
    const selectedProductName = labelValue.textContent.trim();
    let productTitle = document
      .querySelector(".product-title")
      .textContent.trim();

    if (productTitle == "bobobark") {
      checkBoboCroco(selectedProductName);
    }

    if (productTitle == "bebebark") {
      checkBebeCroco(selectedProductName);
    }

    if (productTitle == "doquintin") {
      checkDoquintin();
    }

    // if (productTitle == "GIFT CARD") {
    //   checkGiftCard(selectedProductName);
    // }

    if (productTitle == "bobobark / bebebark Strap (Set of 3)") {
      checkStrap(selectedProductName);
    }

          if (productTitle == "trolala") {
        checkTrolalaCroco(selectedProductName);
    }

    if (labelValue) {
      const availableItemsElement = Array.from(itemNameElements).find(
        (element) => {
          const text = element.textContent.trim();
          return text.startsWith(selectedProductName);
        }
      );

      if (availableItemsElement) {
        const match = availableItemsElement.textContent.match(/(-?\d+)$/);

        if (match && text) {
          const quantity = parseInt(match[1], 10);
          if (quantity < 1 && !button) {
            text.style.display = "block";
          }
          if (quantity < 1 && button) {
            text.style.display = "none";
          }
          if (quantity >= 1) {
            text.style.display = "none";
          }
        }
      }
    }

    if (targetNode) {
      observer.observe(targetNode, {
        childList: true,
        subtree: true,
        characterData: true,
      });
    }
  }

  updateTextAndExtractQuantity();

  //   const addToCartSticky = document.querySelector('product-add-to-cart-sticky');
  //   const selectElementsWrapper = addToCartSticky.querySelector('.variations');
  //   const selectElement = selectElementsWrapper.querySelector('select');

  //   console.log(selectElement)

  // selectElement.addEventListener('change', () => {
  //   console.log("change select")
  // });

  // Получаем геолокацию пользователя из localStorage
  const userGeolocation = localStorage.getItem("userGeolocation");

  // Проверка на геолокацию и скрытие недоступных вариантов
  hideUnavailableVariants(userGeolocation);
  clickFirstVisibleLabel();

  // Функция для скрытия недоступных вариантов
  function hideUnavailableVariants(userGeolocation) {
    // Извлекаем все элементы мета-полей для США и остальных стран
    const usMetaItems = document.querySelectorAll(".meta-hide-logic-us__item");
    const restMetaItems = document.querySelectorAll(
      ".meta-hide-logic-rest__item"
    );

    // Находим все fieldset, внутри которых могут находиться варианты
    const fieldsets = document.querySelectorAll(
      "fieldset.product-form__input--color, fieldset.product-form__input--block"
    );

    if (!fieldsets.length) {
      setTimeout(() => hideUnavailableVariants(userGeolocation), 1000);
      return;
    }

    fieldsets.forEach((fieldset) => {
      usMetaItems.forEach((metaItem) => {
        const shouldHideUS =
          metaItem.querySelector("#meta-hide-logic-us-data").textContent ===
          "true";
        const variantNameUS = metaItem.querySelector(
          "#meta-hide-logic-us-variant-name"
        ).textContent;

        if (shouldHideUS && userGeolocation === "US") {
          hideVariant(fieldset, variantNameUS);
        }
      });

      restMetaItems.forEach((metaItem) => {
        const shouldHideRest =
          metaItem.querySelector("#meta-hide-logic-rest-data").textContent ===
          "true";
        const variantNameRest = metaItem.querySelector(
          "#meta-hide-logic-rest-variant-name"
        ).textContent;

        if (shouldHideRest && userGeolocation !== "US") {
          hideVariant(fieldset, variantNameRest);
        }
      });
    });
  }

  // Функция для скрытия конкретного варианта по его названию
  function hideVariant(fieldset, variantName) {
    // Находим все labels внутри fieldset
    const labels = fieldset.querySelectorAll("label");
    labels.forEach((label) => {
      if (variantName.includes("/")) {
        console.log("smart product");

        const [productTypeToHide, productColorToHide] = variantName
          .split("/")
          .map((item) => item.trim());

        const stickyAddToCartLabels = document.querySelectorAll(
          'product-add-to-cart-sticky .product-form__input--dropdown[data-handle="color"] select option'
        );

        if (productTypeToHide == variantTypeActive) {
          // Находим все fieldset, внутри которых могут находиться варианты
          const fieldsets = document.querySelectorAll(
            "fieldset.product-form__input--color"
          );

          if (!fieldsets.length) return;

          fieldsets.forEach((fieldset) => {
            // Ищем первый видимый label и кликаем по нему
            const visibleLabel = Array.from(
              fieldset.querySelectorAll("label")
            ).find((label) => label.style.display !== "none");

            if (visibleLabel) {
              // visibleLabel.click();
            }
          });

          stickyAddToCartLabels.forEach((label) => {
            if (label.textContent.trim() === productColorToHide) {
              label.style.display = "none";
            }
          });

          if (label.textContent.trim() === productColorToHide) {
            label.style.display = "none";
          }
        } else {
          label.style.display = "flex";

          stickyAddToCartLabels.forEach((label) => {
            label.style.display = "flex";
          });
        }
      } else {
        if (label.textContent.trim() === variantName) {
          // Скрываем label, если вариант должен быть скрыт
          label.style.display = "none";

          // Также скрываем связанный input, если это необходимо
          const input = fieldset.querySelector(`input[value="${variantName}"]`);
          if (input) {
            input.style.display = "none";
          }
        }
      }
    });

    // Проверяем, остался ли только один видимый label
    const visibleLabels = Array.from(labels).filter(
      (label) => label.style.display !== "none"
    );
    if (visibleLabels.length === 0) {
      const addToCartButton = document.getElementById("AddToCart");
      const addToCartButtonAddon = document.getElementById("AddToCartAddons");
      const addToCartButtonSticky = document.getElementById("AddToCartSticky");
      if (addToCartButtonSticky) {
        addToCartButtonSticky.textContent = "Out of stock";
        addToCartButtonSticky.disabled = true; // Делаем кнопку неактивной
      }

      if (addToCartButtonAddon) {
        addToCartButtonAddon.textContent = "Out of stock";
        addToCartButtonAddon.disabled = true; // Делаем кнопку неактивной
      }

      if (addToCartButton) {
        addToCartButton.textContent = "Out of stock";
        addToCartButton.disabled = true; // Делаем кнопку неактивной
      }
    }
  }

  // Функция для клика по первому видимому label
  function clickFirstVisibleLabel() {
    // Находим все fieldset, внутри которых могут находиться варианты
    const fieldsets = document.querySelectorAll(
      "fieldset.product-form__input--color, fieldset.product-form__input--block"
    );

    if (!fieldsets.length) return;

    fieldsets.forEach((fieldset) => {
      // Ищем первый видимый label и кликаем по нему
      const visibleLabel = Array.from(fieldset.querySelectorAll("label")).find(
        (label) => label.style.display !== "none"
      );

      if (visibleLabel) {
        // visibleLabel.click();
      }
    });
  }

  function handleQuickViewPopup() {
    console.log("quick view");
    // Здесь вызываем функцию с текущей геолокацией пользователя
    const userGeolocation = localStorage.getItem("userGeolocation");
    hideUnavailableVariants(userGeolocation);
    clickFirstVisibleLabel();
  }

  function removeUnavailableOptionsByMeta(userGeolocation) {
    // Ищем все элементы <product-add-to-cart-sticky>
    const stickyElements = document.querySelectorAll(
      "product-add-to-cart-sticky"
    );

    if (!stickyElements.length) return;

    // Получаем мета-поля для определения доступности вариантов
    const usMetaItems = document.querySelectorAll(".meta-hide-logic-us__item");
    const restMetaItems = document.querySelectorAll(
      ".meta-hide-logic-rest__item"
    );

    stickyElements.forEach((stickyElement) => {
      // Ищем все select внутри текущего элемента
      const selects = stickyElement.querySelectorAll("select");

      selects.forEach((select) => {
        // Проходим по каждому option
        const options = Array.from(select.options);

        options.forEach((option) => {
          const optionValue = option.value.trim(); // Имя варианта

          // Проверяем доступность варианта для текущей геолокации
          const shouldHide = checkOptionAvailability(
            optionValue,
            userGeolocation,
            usMetaItems,
            restMetaItems
          );

          if (shouldHide) {
            // Удаляем недоступный вариант
            option.remove();
          }
        });

        // Если после удаления не осталось доступных вариантов
        if (select.options.length === 0) {
          const addToCartButton = document.getElementById("AddToCartSticky");
          if (addToCartButton) {
            addToCartButton.textContent = "Out of stock";
            addToCartButton.disabled = true;
          }
        }
      });
    }); 
  }

  // Функция проверки доступности варианта
  function checkOptionAvailability(
    optionValue,
    userGeolocation,
    usMetaItems,
    restMetaItems
  ) {
    let isUnavailable = false;

    if (userGeolocation === "US") {
      usMetaItems.forEach((metaItem) => {
        const shouldHideUS =
          metaItem.querySelector("#meta-hide-logic-us-data").textContent ===
          "true";
        const variantNameUS = metaItem.querySelector(
          "#meta-hide-logic-us-variant-name"
        ).textContent;

        if (shouldHideUS && variantNameUS.trim() === optionValue) {
          isUnavailable = true;
        }
      });
    } else {
      restMetaItems.forEach((metaItem) => {
        const shouldHideRest =
          metaItem.querySelector("#meta-hide-logic-rest-data").textContent ===
          "true";
        const variantNameRest = metaItem.querySelector(
          "#meta-hide-logic-rest-variant-name"
        ).textContent;

        if (shouldHideRest && variantNameRest.trim() === optionValue) {
          isUnavailable = true;
        }
      });
    }

    return isUnavailable;
  }

  // Пример вызова функции
  removeUnavailableOptionsByMeta(userGeolocation);
});
